document.addEventListener('DOMContentLoaded', function () {
	// Bouton d'ouverture
	if (!document.querySelector('.mm-btn-text-2')) {
		return;
	}
	document.querySelector('.mm-btn-text-2').addEventListener('click', function () {
		document.querySelectorAll('.mm-overlay-rainbow').forEach((overlay) => {
			overlay.style.display = 'flex'; // Afficher l'overlay
		});
		document.querySelectorAll('.media-rainbow').forEach((media) => {
			media.style.display = 'flex'; // Afficher la vidéo
			const video = media.querySelector('video');
			if (video) {
				// Copier data-src vers src pour la balise video elle-même
				if (video.dataset.src && !video.src) {
					video.src = video.dataset.src;
				}
				// Copier data-src vers src pour tous les éléments source
				const sources = video.querySelectorAll('source');
				sources.forEach((source) => {
					if (source.dataset.src && !source.src) {
						source.src = source.dataset.src;
					}
				});
				video.load();
				video.play().catch((err) => console.error('Erreur lors de la lecture de la vidéo:', err));
			}
		});
		document.body.classList.add('no-scroll'); // Désactiver le défilement
	});

	// Boutons de fermeture
	document.querySelectorAll('.close-btn').forEach((closeBtn) => {
		closeBtn.addEventListener('click', function () {
			document.querySelectorAll('.mm-overlay-rainbow').forEach((overlay) => {
				overlay.style.display = 'none'; // Cacher l'overlay
			});
			document.querySelectorAll('.media-rainbow').forEach((media) => {
				media.style.display = 'none'; // Cacher la vidéo
				const video = media.querySelector('video');
				if (video) {
					video.pause(); // Mettre la vidéo en pause
					video.currentTime = 0; // Remettre la vidéo au début
					video.src = ''; // Retirer la source pour libérer les ressources
					// Retirer aussi les sources des éléments source
					const sources = video.querySelectorAll('source');
					sources.forEach((source) => {
						source.src = '';
					});
				}
			});
			document.body.classList.remove('no-scroll'); // Réactiver le défilement
		});
	});

	// Fermer l'overlay quand on clique en dehors de la vidéo
	document.querySelectorAll('.mm-overlay-rainbow').forEach((overlay) => {
		overlay.addEventListener('click', function (event) {
			if (event.target === overlay) {
				// Vérifier si on clique sur l'overlay et pas l'intérieur
				overlay.style.display = 'none';
				document.querySelectorAll('.media-rainbow').forEach((media) => {
					media.style.display = 'none';
					const video = media.querySelector('video');
					if (video) {
						video.pause(); // Mettre la vidéo en pause
						video.currentTime = 0; // Remettre la vidéo au début
						video.src = ''; // Retirer la source pour libérer les ressources
					}
				});
				document.body.classList.remove('no-scroll');
			}
		});
	});
});
